import { useEffect, useState } from 'react';
import { Button, Card, Col, Form, Row } from 'react-bootstrap';
import { useNavigate, useParams } from 'react-router-dom';
import Swal from 'sweetalert2';
import { fetchInstallationById, updateInstallationById } from '../../api/installation';

const ScheduleInstallation = () => {
    const { id } = useParams(); // this is inspectionId
    const navigate = useNavigate();

    const [customer, setCustomer] = useState(null);
    const [loading, setLoading] = useState(true);
    const [form, setForm] = useState({
        scheduleDate: '',
        scheduleTime: '',
        assignedPerson: '',
        notes: ''
    });

    const handleChange = (e) => {
        setForm({ ...form, [e.target.name]: e.target.value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            await updateInstallationById(id, form);

            Swal.fire({
                icon: 'success',
                title: 'Application Submitted!',
                text: 'Customer profile has been verified successfully.',
                confirmButtonText: 'OK'
            }).then(() => {
                navigate('/field/inspection/pending');
            });
        } catch (err) {
            console.error('Error submitting application:', err);
            alert('There was an error. Please try again.');
        }
    };

    useEffect(() => {
        const loadInspection = async () => {
            try {
                const res = await fetchInstallationById(id);
                const inspection = res.data.data;
                setCustomer(inspection); // assuming the customer info is included
                setForm({
                    scheduleDate: inspection.scheduleDate || '',
                    scheduleTime: inspection.scheduleTime || '',
                    assignedPerson: inspection.assignedPerson || '',
                    notes: inspection.notes || '',
                    status: 'Scheduled'
                });
            } catch (err) {
                console.error('Error fetching installation:', err);
            } finally {
                setLoading(false);
            }
        };

        loadInspection();
    }, [id]);

    if (loading) return <p>Loading...</p>;
    if (!customer) return <p>Inspection or customer not found.</p>;

    return (
        <div className="container">
            <h3 className="mb-4">Edit Inspection Schedule</h3>

            <Card className="mb-4">
                <Card.Header className='bg-primary text-white'>Customer Info</Card.Header>
                <Card.Body>
                    <p><strong>Name:</strong> {customer.customer.firstName} {customer.customer.lastName}</p>
                    <p><strong>Address:</strong> {customer.customer.address}</p>
                    <p><strong>Contact:</strong> {customer.customer.mobile1 || customer.customer.mobile2}</p>
                </Card.Body>
            </Card>

            <Card>
                <Card.Header>Inspection Schedule</Card.Header>
                <Card.Body>
                    <Form onSubmit={handleSubmit}>
                        <Row className="mb-3">
                            <Col md={6}>
                                <Form.Group>
                                    <Form.Label>Inspection Date</Form.Label>
                                    <Form.Control
                                        type="date"
                                        name="scheduleDate"
                                        value={form.scheduleDate}
                                        onChange={handleChange}
                                        required
                                    />
                                </Form.Group>
                            </Col>
                            <Col md={6}>
                                <Form.Group>
                                    <Form.Label>Inspection Time</Form.Label>
                                    <Form.Control
                                        type="time"
                                        name="scheduleTime"
                                        value={form.scheduleTime}
                                        onChange={handleChange}
                                        required
                                    />
                                </Form.Group>
                            </Col>
                        </Row>

                        <Form.Group className="mb-3">
                            <Form.Label>Assigned Inspector</Form.Label>
                            <Form.Select name="assignedPerson" value={form.assignedPerson} onChange={handleChange} required>
                                <option value="">Select Inspector</option>
                                <option value="Inspector A">Inspector A</option>
                                <option value="Inspector B">Inspector B</option>
                                <option value="Inspector C">Inspector C</option>
                            </Form.Select>
                        </Form.Group>

                        <Form.Group className="mb-3">
                            <Form.Label>Notes</Form.Label>
                            <Form.Control
                                as="textarea"
                                name="notes"
                                value={form.notes}
                                onChange={handleChange}
                                rows={3}
                            />
                        </Form.Group>

                        <Button variant="primary" type="submit">
                            Update Inspection
                        </Button>
                    </Form>
                </Card.Body>
            </Card>
        </div>
    );
};

export default ScheduleInstallation;
